
import { useStore } from "vuex";
import { computed } from "vue";
import _ from "lodash";

export default {
  emits: ["done", "close"],
  setup(props: {}, context: { emit: Function }) {
    const store = useStore();
    const locale = computed((): string => store.state.config.config.appLocale);

    const locales = {
      en: "English",
      ca: "Català",
      es: "Español",
      he: "עִבְרִית",
      pt: "Português"
    };

    return {
      handleLocaleSelect: (locale: string) => {
        store.commit("config/PATCH_CONFIG", { appLocale: locale });
        context.emit("done");
      },
      locales: computed(() => {
        const keys = _.map(
            [..._.keys(Array(_.keys(locales).length))],
            v =>
              _.findKey(
                store.state.config.config.appLocalesOrder,
                l => l === +v
              )!
          ),
          values = _.map(keys, k => _.get(locales, k));

        return _.zipObject(keys, values);
      }),
      locale
    };
  }
};
